module.exports = __webpack_public_path__ + "img/spa-attendant.e26ab8bb.svg";